import { SubmissionError } from 'redux-form';
import { replace } from 'react-router-redux';

import getLocalRepresentative from '../../utils/localRepresentative/getLocalRepresentative';
import { relevantRepresentatives } from '../../utils/localRepresentative/parser';
import { width } from '../../utils/size';
import { CardTypes } from '../../utils/enums';

import {
    ACTION_INITIATED,
    ACTION_INITIATED_LOCAL_REP,
    SHOW_NEXT_ACTION_ANIMATION
} from '../Widget/actions';

import { addressValidationError } from '../../containers/Widget/actions';

export const FIND_LOCAL_REP_POPUP_LOADING = 'FIND_LOCAL_REP_POPUP_LOADING';
export const IS_LOCAL_REP_LOADING = 'IS_LOCAL_REP_LOADING';
export const LOCAL_REP_GO_TO_ACTION = 'LOCAL_REP_GO_TO_ACTION';
export const LOCAL_REP_GO_TO_FIND_SCREEN = 'LOCAL_REP_GO_TO_FIND_SCREEN';
export const ON_FIND_YOUR_REP_ERROR = 'ON_FIND_YOUR_REP_ERROR';
export const ON_FIND_YOUR_REP_POPUP = 'ON_FIND_YOUR_REP_POPUP';
export const ON_DOUBLECHECK_REP_POPUP = 'ON_DOUBLECHECK_REP_POPUP';
export const ON_HIDE_REPRESENTATIVE = 'ON_HIDE_REPRESENTATIVE';
export const ON_SHOW_LIST_WITH_REPS = 'ON_SHOW_LIST_WITH_REPS';
export const ON_SHOW_REPRESENTATIVE = 'ON_SHOW_REPRESENTATIVE';
export const SET_ACTIVE_ACTION = 'SET_ACTIVE_ACTION';
export const SET_LOCAL_REPRESENTATIVE = 'SET_LOCAL_REPRESENTATIVE';
export const LOCAL_REP_SET_BY_USER_INPUT_ADDRESS = 'LOCAL_REP_SET_BY_USER_INPUT_ADDRESS';
export const CLOSE_DOUBLE_CHECK_REP_POPUP = 'CLOSE_DOUBLE_CHECK_REP_POPUP';
export const TOGGLE_DOUBLE_CHECK_REP_POPUP = 'TOGGLE_DOUBLE_CHECK_REP_POPUP';
export const SET_REP_DOUBLE_CHECK_LOADING = 'SET_REP_DOUBLE_CHECK_LOADING';
export const SHOULD_PROMPT_REP_DOUBLE_CHECK = 'SHOULD_PROMPT_REP_DOUBLE_CHECK';

export const hideFindRepPopup = () => dispatch => {
    dispatch({
        type: ON_FIND_YOUR_REP_POPUP,
        payload: false
    });

    dispatch({
        type: ON_DOUBLECHECK_REP_POPUP,
        payload: false
    });
};

export const goToFindLocalRep = (actionIdentifier, route) => dispatch => {
    dispatch({
        type: SET_ACTIVE_ACTION,
        payload: { actionIdentifier }
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: LOCAL_REP_GO_TO_FIND_SCREEN,
        payload: actionIdentifier
    });

    setTimeout(() => {
        dispatch({
            type: ACTION_INITIATED_LOCAL_REP,
            payload: actionIdentifier
        });
    }, 1000);

    dispatch(replace(`/${route}/findRep`));
};

export const hideFindRepCard = (cardType, nextActionType) => dispatch => {
    dispatch({
        type: LOCAL_REP_GO_TO_FIND_SCREEN,
        payload: null
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    if (cardType === CardTypes.multipleActions) {
        dispatch(replace('/multiActionsCard'));
    } else if (cardType === CardTypes.targetedMultiAction) {
        dispatch(replace('/targetedMultiAction'));
    } else if (cardType === CardTypes.actionChoice) {
        dispatch(replace('/actionChoiceCard'));
    } else {
        dispatch(replace(`/${nextActionType}/start`));
    }
};

const repTitle = rep => {
    const office = rep.officeName;
    if (office.indexOf('Governor') !== -1) {
        if (office.indexOf('Lieutenant') !== -1) {
            return 'Lt. Gov.';
        }
        return 'Gov.';
    } else if (office.indexOf('Senate') !== -1) {
        if (office.indexOf('State') !== -1 && office.indexOf('United States') === -1) {
            return 'State Sen.';
        }
        return 'Sen.';
    } else if (office.indexOf('Assembly') !== -1) {
        return 'Assembly Member';
    } else if (
        office.indexOf('Representative') !== -1 ||
        office.indexOf('House') !== -1
    ) {
        if (office.indexOf('State') !== -1 && office.indexOf('United States') === -1) {
            return 'State Rep.';
        }
        return 'Rep.';
    }
};
const formatRepNameByLevel = rep => {
    const last = rep.fullName.split(' ').pop();
    const title = repTitle(rep);
    if (title) return `${title} ${last}`;
    else return last;
};

const repDataWithShortRepNames = repData => {
    let augmentedRepData = repData;
    augmentedRepData.representative = repData.representative.map(r => ({
        ...r,
        shortName: formatRepNameByLevel(r),
        title: repTitle(r)
    }));
    return augmentedRepData;
};

export const onFindYourRep = () => dispatch => {
    dispatch({
        type: ON_FIND_YOUR_REP_POPUP,
        payload: true
    });
};

export const toggleDoubleCheckRepPopup = () => dispatch =>
    dispatch({ type: TOGGLE_DOUBLE_CHECK_REP_POPUP });

export const loadLocalRepSecondaryAddressCheck = (
    address,
    search,
    maxSearch,
    presetRepData
) => dispatch => {
    const presetReps = presetRepData.map(rep => rep.fullName);
    dispatch({ type: LOCAL_REP_SET_BY_USER_INPUT_ADDRESS });
    dispatch({ type: SET_REP_DOUBLE_CHECK_LOADING, payload: true });

    return getLocalRepresentative(null, address, maxSearch).then(data => {
        const reps =
            relevantRepresentatives(search, data.representative).map(
                rep => rep.fullName
            ) || [];
        const repMatch = reps.every(rep => presetReps.indexOf(rep) > -1);

        if (!repMatch) {
            dispatch({ type: SHOULD_PROMPT_REP_DOUBLE_CHECK, payload: true });
            dispatch({
                type: SET_LOCAL_REPRESENTATIVE,
                payload: repDataWithShortRepNames(data)
            });
        }
        dispatch({ type: SET_REP_DOUBLE_CHECK_LOADING, payload: false });
    });
};

export const loadLocalRep = (
    endUserLocation,
    address,
    search,
    isCalledFromForm
) => dispatch => {
    if (!isCalledFromForm) {
        dispatch({
            type: IS_LOCAL_REP_LOADING,
            payload: true
        });
    } else {
        dispatch({
            type: FIND_LOCAL_REP_POPUP_LOADING,
            payload: true
        });
    }

    return getLocalRepresentative(endUserLocation, address, search)
        .then(data => {
            if (data.representative.length === 0 && !!address) {
                // if user entered the address, and nothing was found
                return Promise.reject('NoRepsFound');
            }

            dispatch({
                type: SET_LOCAL_REPRESENTATIVE,
                payload: repDataWithShortRepNames(data)
            });

            dispatch({
                type: ON_FIND_YOUR_REP_POPUP,
                payload: false
            });

            if (!isCalledFromForm) {
                dispatch({
                    type: IS_LOCAL_REP_LOADING,
                    payload: false
                });
            } else {
                dispatch({
                    type: FIND_LOCAL_REP_POPUP_LOADING,
                    payload: false
                });
            }

            addressValidationError(false)(dispatch);
            if (typeof window !== 'undefined') window.dispatchEvent(new Event('resize'));
        })
        .catch(reason => {
            if (isCalledFromForm) {
                let error = 'ISSUE FINDING YOUR REP. PLEASE TRY AGAIN';
                if (reason === 'NotUsBasedError') error = 'ADDRESSES MUST BE US BASED';
                if (reason === 'NoRepsFound')
                    error = 'OFFICIAL IS NOT AVAILABLE IN YOUR AREA';

                addressValidationError(error)(dispatch);
                dispatch({
                    type: FIND_LOCAL_REP_POPUP_LOADING,
                    payload: false
                });

                throw new SubmissionError({
                    _error: error
                });
            } else {
                dispatch({
                    type: IS_LOCAL_REP_LOADING,
                    payload: false
                });
            }
        });
};

export const selectAction = identifier => dispatch => {
    dispatch({
        type: ACTION_INITIATED,
        payload: identifier
    });

    var buttonClicked = document.querySelectorAll(
        '[data-action="' + identifier + '"]'
    )[0];
    if (buttonClicked) {
        buttonClicked.classList.add('clicked');
    }
    return;
};

export const onDeleteClick = item => dispatch => {
    dispatch({
        type: ON_HIDE_REPRESENTATIVE,
        payload: item
    });
    window.dispatchEvent(new Event('resize'));
};

export const onAddClick = item => dispatch => {
    dispatch({
        type: ON_SHOW_REPRESENTATIVE,
        payload: item
    });
    window.dispatchEvent(new Event('resize'));
};

export const onShowRepresentatives = () => dispatch => {
    setTimeout(() => {
        if (document.getElementById('addButton')) {
            const addButton = document.getElementById('addButton');
            const addButtonPosition = document
                .getElementById('addButton')
                .getBoundingClientRect().left;
            addButton.classList += ' visible';
            if (width() / 2 < addButtonPosition) {
                addButton.classList += ' to-right';
            }
        }
    });

    dispatch({
        type: ON_SHOW_LIST_WITH_REPS
    });
};
